export function EventsTabSkeleton() {
    return (
        <div className="flex flex-col">
            <div className="w-full aspect-video skeleton-item-container rounded-lg" />

            <div className="mt-6 flex flex-col gap-3 skeleton-item-container rounded-md min-h-[120px]">
                <div
                    className="h-[22px] w-[80px] shrink-0 opacity-0"
                    aria-hidden
                />
                <div
                    className="h-[38px] w-full max-w-[400px] shrink-0 opacity-0"
                    aria-hidden
                />
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div
                            className="h-4 w-[120px] shrink-0 opacity-0"
                            aria-hidden
                        />
                        <div
                            className="h-4 w-[100px] shrink-0 opacity-0"
                            aria-hidden
                        />
                    </div>
                    <div
                        className="h-4 w-[140px] shrink-0 opacity-0"
                        aria-hidden
                    />
                </div>
            </div>
        </div>
    );
}
